import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DATE_RANGE_SELECTION_STRATEGY } from '@angular/material/datepicker';
import { auditTime, debounceTime, distinctUntilChanged, pairwise, startWith } from 'rxjs/operators';
import { BotDateRange } from '../../../core/models/bot.model';
import { DateRangeSelectionStrategy } from '../../utility/date-range-selection.strategy';

@Component({
  selector: 'brn-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
  providers: [
    {
      provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
      useClass: DateRangeSelectionStrategy,
    },
  ],
})
export class DateRangePickerComponent {
  private _period!: BotDateRange;

  @Input()
  class?: string;

  @Input()
  set period(period: BotDateRange) {
    if (JSON.stringify(this.period) === JSON.stringify(period)) {
      return;
    }

    this._period = period;
    this.periodGroup.patchValue(this.period, { emitEvent: false });
  }

  get period(): BotDateRange {
    return this._period;
  }

  @Output()
  periodChange = new EventEmitter<BotDateRange>();

  periodGroup: FormGroup = this.fb.group({
    from: [undefined, [Validators.required]],
    to: [undefined, [Validators.required]],
  });

  constructor(private fb: FormBuilder) {
    this.periodGroup.valueChanges
      .pipe(
        startWith(this.periodGroup.value),
        pairwise(),
        auditTime(1000),
        distinctUntilChanged()
      )
      .subscribe(([prev, curr]: [BotDateRange, BotDateRange]) => {
        if (curr.from && curr.to && (prev.from !== curr.from || prev.to !== curr.to)) {
          this.periodChange.emit(curr);
        }
      });
  }
}